import { OrderStageId, OrderStageResponse } from '@business/entities/order';
import { Endpoint } from '../endpoint';

export function fetchStages() {
  return Endpoint.get<OrderStageResponse[]>(`@gc/stages`);
}

export function fetchStage(id: OrderStageId) {
  return Endpoint.get<OrderStageResponse>(`@gc/stages/stage/${id}`);
}

export function createStage(data: Partial<OrderStageResponse>) {
  return Endpoint.post<OrderStageResponse>(`@gc/stages`, { data });
}

export function updateStage(id: OrderStageId, data: Partial<OrderStageResponse>) {
  return Endpoint.patch<OrderStageResponse>(`@gc/stages/${id}`, { data });
}

export function deleteStage(id: OrderStageId) {
  return Endpoint.delete<void>(`@gc/stages/${id}`);
}

export function updateStatus(id: OrderStageId) {
  return Endpoint.post<OrderStageResponse>(`@gc/stages/status/${id}`);
}
